// extracted by mini-css-extract-plugin
module.exports = {"cartoes":"Cartao_cartoes__1-Kil","mobile":"Cartao_mobile__3XmRv","cartao":"Cartao_cartao__2qLEX","ativo":"Cartao_ativo__3fu5g"};